import { Storage } from 'react-jhipster';
import i18n from './i18n';

export type AppDateLocaleConfig = {
    intlLocale: 'pt-BR' | 'en-US';
    datePickerLocale: 'pt-BR' | 'en-US';
    datePickerFormat: 'dd/MM/yyyy' | 'MM/dd/yyyy';
    datePickerPlaceholder: 'dd/mm/yyyy' | 'mm/dd/yyyy';
    parseFormats: string[];
};

const EN_CONFIG: AppDateLocaleConfig = {
    intlLocale: 'en-US',
    datePickerLocale: 'en-US',
    datePickerFormat: 'MM/dd/yyyy',
    datePickerPlaceholder: 'mm/dd/yyyy',
    parseFormats: ['MM/DD/YYYY', 'MM/DD/YYYY HH:mm:ss', 'MM/DD/YYYY HH:mm'],
};

const PT_CONFIG: AppDateLocaleConfig = {
    intlLocale: 'pt-BR',
    datePickerLocale: 'pt-BR',
    datePickerFormat: 'dd/MM/yyyy',
    datePickerPlaceholder: 'dd/mm/yyyy',
    parseFormats: ['DD/MM/YYYY', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY HH:mm'],
};

const normalizeLang = (lang: string) => lang.trim().toLowerCase();

const resolveLanguage = (language?: string) => {
    if (language && language.trim()) return normalizeLang(language);

    const i18nLang = normalizeLang(i18n.resolvedLanguage || i18n.language || '');
    const sessionLocale = normalizeLang(String(Storage.session.get('locale', '') || ''));
    const localLocale = normalizeLang(String(Storage.local.get('locale', '') || ''));

    return i18nLang || sessionLocale || localLocale || 'pt-br';
};

export const getDateLocaleConfig = (language?: string): AppDateLocaleConfig => {
    const effective = resolveLanguage(language);
    return effective.startsWith('en') ? EN_CONFIG : PT_CONFIG;
};

